import styled from 'styled-components'

export const IntegrationsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(420px, 1fr));
  gap: ${props => props.theme.spacing.sp16};
`
